// extracted by mini-css-extract-plugin
export var hidden = "_4r-1";
export var leftPanel = "_4r-2";
export var readonlyInspector = "_4r-3";
export var rightPanel = "_4r-0";